import { useContext } from 'react';
import { BreadcrumbContext, BreadcrumbContextValue } from '../contexts/breadcrumbContextDef';

export function useBreadcrumb(): BreadcrumbContextValue {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
  }
  return context;
}
